export const formatCommonAmount = (amount) => {
	if (!amount) return '--'
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	}).format(amount)
}
